<div class="actions">
  <button uxa-icon-button
    class="btn btn-icon btn-link"
    type="button"
    uxaTooltip="Show All"
    uxaTooltipPlacement="above"
    (click)="toggleAllTechniques()">
    <uxa-icon name="selectAll" class="mitre-flipped-both" />
  </button>
  <button uxa-icon-button
    class="btn btn-icon btn-link"
    type="button"
    uxaTooltip="Sub-Techniques"
    uxaTooltipPlacement="above"
    (click)="toggleSubTechniques()">
    <uxa-icon name="organizationChart" />
  </button>
  <button uxa-icon-button
    class="btn btn-icon btn-link"
    type="button"
    uxaTooltip="Export"
    uxaTooltipPlacement="above"
    (click)="export()">
    <uxa-icon name="upload" />
  </button>
</div>
